import { c as _c } from "react-compiler-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import { NavMarker } from 'react-rhumb';
import { Text } from 'foundations-components/components/Text';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function getMessageKey(errorType) {
  switch (errorType) {
    case 'TOKEN_EXPIRED':
      return 'universal-recording-review-public-ui.error.expired';
    case 'TOKEN_REVOKED':
      return 'universal-recording-review-public-ui.error.revoked';
    default:
      return 'universal-recording-review-public-ui.error.invalid';
  }
}
export function ExpiredOrInvalidPage(t0) {
  const $ = _c(5);
  const {
    errorType
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = /*#__PURE__*/_jsx(Text, {
      typography: "heading-300",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "universal-recording-review-public-ui.error.title"
      })
    });
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== errorType) {
    t2 = getMessageKey(errorType);
    $[1] = errorType;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = /*#__PURE__*/_jsx(NavMarker, {
      name: "SHARE_PAGE_ERROR",
      children: /*#__PURE__*/_jsxs(Flex, {
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: "600",
        gap: "300",
        minBlockSize: "50vh",
        children: [t1, /*#__PURE__*/_jsx(Text, {
          typography: "body-200",
          color: "text-core-subtle",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: t2
          })
        })]
      })
    });
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}